import { Controller } from "@hotwired/stimulus"
import EmblaCarousel from "embla-carousel"

export default class extends Controller {
  static targets = ["qty", "details", "icon", "thumbnails", "viewport"]

  connect() {
    this.embla = EmblaCarousel(this.viewportTarget, { loop: false, dragFree: true, containScroll: 'keepSnaps', align: 'start', slidesToScroll: 1 })
  }

  disconnect() {
    if (this.embla) this.embla.destroy()
  }

  increase() {
    let current = parseInt(this.qtyTarget.textContent, 10)
    this.qtyTarget.textContent = current + 1
  }

  decrease() {
    let current = parseInt(this.qtyTarget.textContent, 10)
    if (current > 1) {
      this.qtyTarget.textContent = current - 1
    }
  }

  toggleDetails(event) {
    const details = event.currentTarget
    const icon = details.querySelector('[data-souvenir-product-target="icon"] svg')
    if (details.open) {
      icon.innerHTML = `<path fill-rule="evenodd" clip-rule="evenodd" d="M11.929 8.929L6.272 14.586L7.686 16L12.636 11.05L17.586 16L19 14.586L13.343 8.929C13.1555 8.74153 12.9012 8.63621 12.636 8.63621C12.3708 8.63621 12.1165 8.74153 11.929 8.929Z" fill="black"/>`
    } else {
      icon.innerHTML = `<path fill-rule="evenodd" clip-rule="evenodd" d="M11.929 15.071L6.272 9.414L7.686 8L12.636 12.95L17.586 8L19 9.414L13.343 15.071C13.1555 15.2585 12.9012 15.3638 12.636 15.3638C12.3708 15.3638 12.1165 15.2585 11.929 15.071Z" fill="black"/>`
    }
  }

  goToSlide(event) {
    const idx = parseInt(event.currentTarget.dataset.index, 10)
    if (this.embla) {
      this.embla.scrollTo(idx)
    }
  }
}